const GOOGLE_OAUTH_CLIENT_ID: string = import.meta.env
  .VITE_GOOGLE_OAUTH_CLIENT_ID
const APP_HOST: string = import.meta.env.VITE_APP_HOST

export class OauthClient {
  googleOauth2Endpoint = 'https://accounts.google.com/o/oauth2/v2/auth'
  scope =
    'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile'

  oauthSignIn() {
    const form = document.createElement('form')
    form.setAttribute('method', 'GET') // Send as a GET request.
    form.setAttribute('action', this.googleOauth2Endpoint)

    const params: Record<string, string> = {
      client_id: GOOGLE_OAUTH_CLIENT_ID,
      redirect_uri: `${APP_HOST}/oauth-google`,
      response_type: 'token',
      scope: this.scope,
      include_granted_scopes: 'true',
      state: 'pass-through value',
    }

    for (const p in params) {
      const input = document.createElement('input')
      input.setAttribute('type', 'hidden')
      input.setAttribute('name', p)
      input.setAttribute('value', params[p])
      form.appendChild(input)
    }

    // Add form to page and submit it to open the OAuth 2.0 endpoint.
    document.body.appendChild(form)
    form.submit()
  }
}
